import React from "react";

export default function About() {
  return (
<div className="my-38">
  <div className="text-center mx-20 my-20 text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
    ABOUT US
  </div>
  <div className="flex mx-5 my-5 px-10">
    {/* Image Section */}
    <div className="w-1/2">
    <img
  src="solutions/about.png"
  alt="About Us"
  className="w-full h-auto rounded-lg shadow-md opacity-80" // Change opacity to 80%
/>

    </div>
    {/* Paragraph Section */}
    <div className="w-1/2 font-serif pl-8">
      <p className="text-justify">
        Robust International Private Limited is a leading provider of comprehensive manpower and support services, specializing in warehousing, logistics, production, hospitality, and office management. 
        With a customer-centric approach, we deliver tailored solutions that enhance operational efficiency and business growth. 
        Backed by a team of experienced professionals, we ensure top-tier service quality, reliability, and compliance with industry standards. 
        Our mission is to be a trusted partner by offering exceptional workforce solutions that drive success and create long-term value for our clients.
         We have pleasure in introducing ourselves as a leading professional expertise in the field of providing manpower services on ‘CONTRACTUAL’ basis. 
         We may please be contacted for the purpose of getting contract workers. Like temporary, casual, seasonal or need-based Work Force which also include, Warehousing, Production, Logistics, House Keeping, loading/unloading, Packaging and assembly, Dispatch, etc.
          as per your requirement arising from time to time. We may assure you that with a team of our large experienced professionals like legal and personal experts and field persons, you will have zero botheration services at a very nominal cost. 
      </p>
    </div>
  </div>
  <div className="pl-14 font-serif mr-14"> {/* Added mr-8 for right margin */}
  <p className="text-justify">
    We have fully computerized office setup. Our field supervisors facilitated with cell phones and bikes just to increase their efficiency level of working and for immediate control over any type of problems. We owe the total responsibility of workers engaged in your premises by us. We adhere to all timely statutory legal compliance in a very systematic way which is required to develop and maintain the long-term transparent association. We believe in the philosophy of “Do What You Commit.” We are confident that our true services shall definitely help your esteemed organization for getting the right manpower.
  </p>
</div>

</div>

  );
}
